import React from "react";
import { Row, Col } from "antd";
import { BACKEND_URL } from "../../../services/backendURL";
import 'antd/dist/antd.css';
import moment from "moment";
import AvatarProfile from "../../../helpers/AvatarProfile";




const truncate = (str) => {
    return str.length > 80 ? str.substring(0, 80) + "..." : str;
};

const truncateDescription = (str) => {
    return str.length > 110 ? str.substring(0, 110) + "..." : str;
};



const NewsCard = ({ item }) => {


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Row gutter={24} align="middle" style={{ padding: "15px" }}>
                    <Col xl={16} lg={16} md={16} sm={16} xs={16}>
                        <AvatarProfile
                            photo={item.member.photo}
                            name={item.member.name}
                            surname={item.member.surname}
                            fullName={item.member.name + " " + item.member.surname}
                        />
                    </Col>
                    <Col xl={8} lg={8} md={8} sm={8} xs={8} className="text-right">
                        {moment(item.publish_date === 'undefined' ? '' : item.publish_date).format("DD-MM-YYYY")}
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                        <img alt="News Logo" style={{ width: "100%", maxHeight: "220px", height: "220px" }} src={BACKEND_URL + item.photo} />
                    </Col>
                </Row>
                <Row gutter={24} className="m-2">
                    <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                        <b><h5 className="mt-2">{truncate(item?.title === 'undefined' ? '' : item?.title)}</h5></b>
                        <p className="m-0 mb-2 p-0">{truncateDescription(item?.content === 'undefined' ? '' : item?.content)}</p>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};


export default NewsCard;